"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailureReason = void 0;
/** Different failure states as to why a file could not be converted/rendered */
var FailureReason;
(function (FailureReason) {
    FailureReason["TooLarge"] = "TooLarge";
    FailureReason["NotSupported"] = "NotSupported";
    FailureReason["CouldNotConvert"] = "CouldNotConvert";
    FailureReason["UrlInvalid"] = "UrlInvalid";
})(FailureReason || (exports.FailureReason = FailureReason = {}));
